/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

const Tab = {
  key: 'Tab',
  which: 9,
  keyCode: 9,
  code: 'Tab'
};
const Enter = {
  key: 'Enter',
  which: 13,
  keyCode: 13,
  code: 'Enter'
};
const Escape = {
  key: ['Escape',
  // IE11 Escape
  'Esc'],
  which: 27,
  keyCode: 27,
  code: 'Esc'
};
const Space = {
  key: ' ',
  which: 32,
  keyCode: 32,
  code: 'Space'
};
const End = {
  key: 'End',
  which: 35,
  keyCode: 35,
  code: 'Numpad1'
};
const Home = {
  key: 'Home',
  which: 36,
  keyCode: 36,
  code: 'Numpad7'
};
const ArrowLeft = {
  key: 'ArrowLeft',
  which: 37,
  keyCode: 37,
  code: 'ArrowLeft'
};
const ArrowUp = {
  key: 'ArrowUp',
  which: 38,
  keyCode: 38,
  code: 'ArrowUp'
};
const ArrowRight = {
  key: 'ArrowRight',
  which: 39,
  keyCode: 39,
  code: 'ArrowRight'
};
const ArrowDown = {
  key: 'ArrowDown',
  which: 40,
  keyCode: 40,
  code: 'ArrowDown'
};
const Delete = {
  key: 'Delete',
  which: 8 ,
  keyCode: 8 ,
  code: 'ArrowDecimal'
};

export { ArrowDown, ArrowLeft, ArrowRight, ArrowUp, Delete, End, Enter, Escape, Home, Space, Tab };
